import { getSeekerInfo } from '../../../../../apiclient/resources/seeker';
import * as actions from './actions';

const fetchseekerInfo = id => dispatch => {
  dispatch(actions.fetchInfoSeeker());
  getSeekerInfo(id).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchInfoSeekerSucceeded(data));
    } else {
      dispatch(actions.fetchInfoSeekerFailed(error));
    }
  });
};

export const { fetchInfoSeeker, fetchInfoSeekerFailed, fetchInfoSeekerSucceeded } = actions;

export { fetchseekerInfo };
